<template lang="pug">
.fa-icon(:style="{width: size, height: size}")
  font-awesome-icon(:icon="icon")
</template>
<script>
export default {
  props: {
    icon: String,
    size: {
      type: String,
      default: '24px'
    }
  }
}
</script>
<style>
.fa-icon svg {
  width: 100%!important;
  height: 100%!important;
}
</style>
